module.exports = __webpack_public_path__ + "img/check_circle_outline.b7c9dc2d.svg";